<template>
  <div class="accordion">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "AppAccordion",
  props: {
    value: {
      type: Number,
      required: false,
      default: null,
    },
  },
  provide() {
    return {
      accordion: this,
    };
  },
  methods: {
    registerItem(item) {
      if (this.registeredItems.indexOf(item) >= 0) {
        return;
      }

      this.registeredItems.push(item);
      item.$on("hide", this.onHideItem);

      return this.registeredItems.length - 1;
    },
    unregisterItem(item) {
      const index = this.registeredItems.findIndex(ri => ri === item);
      if (index < 0) {
        return;
      }

      this.$delete(this.registeredItems, index);
    },
    onHideItem() {
      this.$nextTick(() => {
        const index = this.registeredItems.findIndex(
          item => item.visible === true
        );
        this.$emit("input", index);
      });
    },
  },
  watch: {
    value: {
      handler(value) {
        if (!this.registeredItems[value]) {
          return;
        }
        this.registeredItems[value].visible = true;
      },
      immediate: true,
    },
    registeredItems: {
      handler(items) {
        if (!items[this.value]) {
          return;
        }
        items.forEach((item, index) => (item.visible = index === this.value));
      },
      immediate: true,
    },
  },
  data() {
    return {
      name: `accordion-${Math.ceil(Math.random() * 100000000000)}`,
      registeredItems: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.accordion {
  ::v-deep {
    .accordion-item {
      &:not(:last-child),
      &.is-visible {
        .accordion-item-title {
          @include border-bottom-radius(0);
        }
      }
      &:not(:first-child) {
        margin-top: -$btn-border-width;
        .accordion-item-title {
          @include border-top-radius(0);
        }
      }
    }
  }
}
</style>
